import { Paginator } from 'foundations-components/transitional/components/Paginator';
import { useSetQueryParams } from '../../app/hooks/useSetQueryParams';
import { Fragment as _Fragment } from "react/jsx-runtime";
import { jsx as _jsx } from "react/jsx-runtime";
const ProductUpdatesTablePaginator = ({
  limit,
  offset,
  totalCount
}) => {
  const page = offset / limit + 1;
  const pageCount = Math.ceil(totalCount / limit);
  const setQueryParams = useSetQueryParams();
  const handlePageChange = ({
    target: {
      value: newPage
    }
  }) => {
    const newOffset = (newPage - 1) * limit;
    setQueryParams({
      offset: newOffset ? newOffset.toString() : ''
    });
  };
  if (pageCount < 2) {
    return /*#__PURE__*/_jsx(_Fragment, {});
  }
  return /*#__PURE__*/_jsx(Paginator, {
    "data-test-id": "product-updates-paginator",
    onPageChange: handlePageChange,
    page: page,
    pageCount: pageCount
  });
};
export default ProductUpdatesTablePaginator;